import {
  Icon,
  IconBuildingWarehouse,
  IconLayoutDashboard,
  IconMessageDots,
  IconReportMoney,
  IconUser,
  IconUsersGroup,
} from "@tabler/icons-react";

interface RouteProps {
  icon: Icon;
  link: string;
  label: string;
}

export const RouteList: RouteProps[] = [
  { icon: IconLayoutDashboard, link: "", label: "Overview" },
  { icon: IconBuildingWarehouse, link: "inventory", label: "Inventory" },
  { icon: IconReportMoney, link: "requests", label: "Sales Requests" },
  { icon: IconUsersGroup, link: "team", label: "Team" },
  // { icon: IconUser, link: "profile", label: "My Profile" },
  { icon: IconMessageDots, link: "messages", label: "Client Messages" },
];
